// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rightControl[data-v-252182a0]{position:absolute;right:0;top:0}", ""]);
// Exports
module.exports = exports;
